// extracted by mini-css-extract-plugin
module.exports = {"IconNav":"icon-module--IconNav---zdOk","IconHeader":"icon-module--IconHeader--2Gakt","IconRed":"icon-module--IconRed--B5ef9","IconBlue":"icon-module--IconBlue--3wZpy"};